<section class="pagination-shell" [attr.aria-busy]="loading" aria-label="Pagination">
  <p class="range" aria-live="polite">
    Showing <strong>{{ rangeStart }}–{{ rangeEnd }}</strong> of
    <strong>{{ totalCount }}</strong> {{ itemLabel }}
  </p>

  <div class="controls">
    <label class="page-size">
      <span>Rows per page</span>
      <select
        [value]="pageSize"
        [disabled]="loading"
        aria-label="Rows per page"
        (change)="changePageSize($any($event.target).value)"
      >
        <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
      </select>
    </label>

    <nav class="page-buttons" aria-label="Page navigation">
      <button type="button" [disabled]="loading || page === 1" aria-label="First page" title="First page" (click)="goToPage(1)">
        <i class="pi pi-angle-double-left" aria-hidden="true"></i>
      </button>
      <button type="button" [disabled]="loading || page === 1" aria-label="Previous page" title="Previous page" (click)="goToPage(page - 1)">
        <i class="pi pi-angle-left" aria-hidden="true"></i>
      </button>
      <button
        *ngFor="let pageNumber of visiblePages"
        type="button"
        class="page-number"
        [class.active]="pageNumber === page"
        [attr.aria-current]="pageNumber === page ? 'page' : null"
        [attr.aria-label]="'Page ' + pageNumber"
        [disabled]="loading"
        (click)="goToPage(pageNumber)"
      >{{ pageNumber }}</button>
      <button type="button" [disabled]="loading || page >= totalPages" aria-label="Next page" title="Next page" (click)="goToPage(page + 1)">
        <i class="pi pi-angle-right" aria-hidden="true"></i>
      </button>
      <button type="button" [disabled]="loading || page >= totalPages" aria-label="Last page" title="Last page" (click)="goToPage(totalPages)">
        <i class="pi pi-angle-double-right" aria-hidden="true"></i>
      </button>
    </nav>
  </div>
</section>
